// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "static/js/" + ({"12":"profiler","777":"recorder"}[chunkId] || chunkId) + "." + {"12":"fa0527ae","72":"073f73f7","477":"7cc08a3e","627":"7b4afcaf","663":"d2e249c6","667":"84d43477","777":"395ac711","803":"f5ab5c4f","820":"6f2fc95a"}[chunkId] + ".chunk.js";
};